import axios from "@/plugins/axios";

let url = "/api/console/estimate/inquiries";

export default {
    getInquiries(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    getInquiry(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    putInquiry(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    postMeasurements(data, image) {
        var formData = new FormData();
        formData.append("measurements", image);
        var headers = { "Content-Type": "multipart/form-data" };
        return axios.post(`${url}/${data._id}/measurements/${data.areaName}/${data.sectionName}/${data.index}`, formData, { headers }).then((result) => result.data);
    },
    postRequest({ _inquiry, _interior }) {
        return axios.post(`${url}/${_inquiry}/interior/${_interior}`, { _inquiry, _interior }).then((result) => result.data);
    },
};
